<template>
    <div class="pagination">
        <img src="@/assets/img/mobile/lease/prest.png" @click="toPrestPage">
        <img src="@/assets/img/mobile/lease/pre.png" @click="toPre">
        <div class="size">
            {{page.pageNum}}/{{maxPage}}
        </div>
        <img src="@/assets/img/mobile/lease/next.png" @click="toNext">
        <img src="@/assets/img/mobile/lease/nextest.png" @click="toNextest">
    </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';
import { Toast } from '@/utils/index';

export default defineComponent({
    setup(props, content) {
        const store = useStore();

        const page = computed(() => {
            return store.state.mobilePage
        });

        const maxPage = computed(() => {
            if (page.value.total === 0) return 1;
            return Math.ceil(page.value.total / page.value.lineNum);
        });

        const toPrestPage = () => {
            if (page.value.pageNum === 1) {
                return;
            }
            store.commit('SET_MOBILE_PAGE', { pageNum: 1 });
            content.emit('pageChange');
        };

        const toNextest = () => {
            if (page.value.pageNum === maxPage.value) {
                return;
            }
            store.commit('SET_MOBILE_PAGE', { pageNum: maxPage.value });
            content.emit('pageChange');
        }

        const toNext = () => {
            if (page.value.pageNum === maxPage.value) {
                return;
            }
            store.commit('SET_MOBILE_PAGE', { pageNum: page.value.pageNum + 1 });
            content.emit('pageChange');
        };

        const toPre = () => {
            if (page.value.pageNum === 1) {
                return;
            }
            store.commit('SET_MOBILE_PAGE', { pageNum: page.value.pageNum - 1 });
            content.emit('pageChange');
        };


        return {
            page,
            maxPage,
            toPre,
            toNext,
            toNextest,
            toPrestPage,
        }
    }
})
</script>

<style lang="less" scoped>
.pagination {
    padding: 0.2rem 0.84rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    img {
        width: 0.85rem;
        height: 0.85rem;
        display: block;
    }
    .size {
        width: 3.07rem;
        height: 0.91rem;
        text-align: center;
        line-height: 0.8rem;
        border: 0.07rem solid #143022;
        border-radius: 0.24rem;
        font-size: 0.37rem;
        color: #202020;
    }
}
</style>